import ComingSoon from "components/ComingSoon";
import React from "react";

const PostgreSQL = () => {
  return <ComingSoon />;
};

export default PostgreSQL;
